import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2Plus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-2-plus, add"} maskId="square-filled-radius-0-stroke-1-IconEmail2Plus"><path d="M22 4V7.55664L21.7266 7.69629L12.2266 12.5176L12 12.6318L11.7734 12.5176L3 8.06348V19H12V20H2V4H22Z" fill="currentColor"/><path d="M20 14V17H23V18H20V21H19V18H16V17H19V14H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail2Plus;
